import types from './types';

export const defaultInitialState = {
    categoryTagsData: {},
    linkUrl: '',
    activeCategoryTagsData: [],
    relatedKeywords: [],
    productList: [],
    categoryPageTags: [],
};

export const createReducers = (types, initialState = defaultInitialState) => {
    return (state = initialState, { type, payload }) => {
        switch (type) {
            case types.SET_NAVIGATION_CATEGORY_TAGS:
                return {
                    ...state,
                    categoryTagsData: {
                        ...state.categoryTagsData,
                        [payload.activeTagMenu]: payload.tags,
                    },
                    linkUrl: payload.linkUrl,
                    activeCategoryTagsData: payload.tags,
                };

            case types.SET_NAVIGATION_CATEGORY_ENDPOINT:
                return {
                    ...state,
                    categoryTagsBaseUrl: payload.baseUrl,
                    categoryTagsApiKey: payload.apiKey,
                    categoryNavNode: payload.navNode,
                    categoryPlpNavNode: payload.plpNavNode,
                    categoryProdSize: payload.pageSize,
                    categoryKeywordPlpNavNode: payload.keywordPlpNavNode,
                };

            case types.CLEAR_NAVIGATION_CATEGORY_TAGS:
                return {
                    ...state,
                    activeCategoryTagsData: [],
                    linkUrl: '',
                };

            case types.SET_RELATED_KEYWORDS:
                return {
                    ...state,
                    relatedKeywords: payload.relatedKeywords,
                    searchKeywords: payload.tag && payload.tag.display,
                    baseProductCodes: payload.baseProducts,
                };

            case types.SET_PRODUCT_LIST:
                return {
                    ...state,
                    productList: payload,
                };

            case types.SET_PRODUCT_CODE_LIST:
                return {
                    ...state,
                    productList: payload,
                };

            case types.GET_CATEGORY_PAGE_TAGS:
                return {
                    ...state,
                    categoryPageTags: payload,
                };

            case types.SET_CURRENT_PAGE: {
                return {
                    ...state,
                    additionalPagination: payload,
                };
            }

            case types.SET_INTEREST_SELECTION_COMPONENTS: {
                return {
                    ...state,
                    interestSelectionComponents: payload,
                };
            }

            case types.SET_INTEREST_SELECTION_KEYWORDS: {
                return {
                    ...state,
                    interestSelectionKeywords: payload,
                };
            }

            case types.SET_INTEREST_SELECTION_COMPONENT_DATA: {
                return {
                    ...state,
                    interestSelectionComponentData: payload,
                };
            }

            default:
                return state;
        }
    };
};

export default createReducers(types);
